import { createSelector } from 'reselect';
import { redux } from 'Core/redux';
import { STORE_KEY, INITIAL_STATE } from './slice';

export const selectState = state => {
  const appState = state || redux.store.getState();
  return appState?.[STORE_KEY] || INITIAL_STATE;
};

export const selectCipRegisterData = state => selectState(state).data;
export const selectCipRegisterLoading = state => selectState(state).loading;
export const selectFetchCipRegisterLoading = state => selectState(state).fetchLoading;
export const selectCipRegisterError = state => selectState(state).error;
export const selectCipRegisterFilterVisible = state => selectState(state).filterVisible;
export const selectCipRegisterFilters = state => selectState(state).filters;
export const selectTileView = state => selectState(state).tileView;

export const selectFilteredCipRegisters = createSelector(
  [selectCipRegisterData, selectCipRegisterFilters],
  (data, { searchText }) => {
    return data.filter(entry =>
      Object.keys(entry).some(key =>
        String(entry[key]).toLowerCase().includes(searchText.toLowerCase()),
      ),
    );
  },
);
